import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Icon, Tooltip} from 'antd'

class InfoTooltip extends Component {
  render() {
    const {value, title} = this.props
    return (
      <span>
        {value}
        <Tooltip title={title}>
          <Icon style={{marginLeft: '6px'}} type="question-circle-o" />
        </Tooltip>
      </span>
    )
  }
}

InfoTooltip.propTypes = {
  value: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}
InfoTooltip.defaultProps = {}

export default InfoTooltip
